// İçerik Kartları / Kampanya Kartı penceresi (web sitesi kart blokları) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.contentCards';

export const contentCardsDialogGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'İçerik kartları nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Bu pencerede web sitenizde gösterilecek bir kart bloğu (hizmet, kampanya, fiyat paketi, adımlar vb.) hazırlarsınız: yerleşim, gösterileceği sayfalar, bölüm başlığı, kartlar ve görünüm. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İçerik Kartları Ekle / Düzenle'),
    body: t(`${G}.regions.body`, 'Yerleşim, sayfa, başlık, kartlar ve önizleme'),
    footer: t(`${G}.regions.footer`, 'Kart Ekle / Taslağı yapıştır / Kapat / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Yerleşimi seçin'),
      text: t(`${G}.s1.text`, '"Yerleşim" bölümündeki küçük resimlerden kartların nasıl dizileceğini seçin: Düz Izgara, 3 Yan Yana Promo, Büyük Sol + 2 Küçük, 2 Küçük + Büyük Sağ, Sol Panel + Izgara, Izgara + Sağ Panel, Öne Çıkan + Izgara veya Özel Sütun. Kampanya kartı penceresinde yalnız promo yerleşimleri çıkar.'),
      tips: [
        t(`${G}.s1.tip1`, 'Değerler şeridi gibi hazır düzenli bloklarda yerleşim seçimi görünmez; kartlar şablonun kendi düzeninde dizilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Sayfayı ve konumu belirleyin'),
      text: t(`${G}.s2.text`, '"Gösterilecek sayfalar" kutusundan bir veya birden fazla sayfa seçin; aynı blok ana sayfada, sekmelerde ve özel sayfalarda birlikte gösterilebilir. En az bir sayfa seçili kalmalıdır. Ana sayfa seçiliyse "Bu bloğun ana sayfadaki konumu", diğer sayfalar için "Diğer sayfalardaki konum" ile bloğun hangi bölümün arasına gireceğini seçin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Hakkımızda, hizmetler, ürün ve iletişim sayfalarında kartı bölümlerin arasına da (ör. Hero\'nun hemen altında, Hikaye bölümünden sonra) yerleştirebilirsiniz.'),
        t(`${G}.s2.tip2`, 'Kampanya kartında bunun yerine "Kart hizası (sol / orta / sağ)" ve "Ana sayfadaki konum" seçilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Bölüm başlığı ve görünüm'),
      text: t(`${G}.s3.text`, '"Bölüm Başlığı (Opsiyonel)" kartların üstünde görünür; yazı tipi, boyut, mini başlık ve bölüm açıklaması da eklenebilir. "Maddelendirme göster", "Konum göster" ve "Tarih göster" kartlara ilgili alanları açar. Izgara yerleşimlerinde Masaüstü / Tablet Sütun, Boşluk (px), Köşe Yuvarlaklığı, Görsel Oranı, hizalar, font, renk ve Bölüm Renkleri ayarlanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Kartları doldurun'),
      text: t(`${G}.s4.text`, 'Her "Kart #n" kutusunda Başlık, Açıklama, görsel ("Görsel Seç" ile kütüphaneden ya da adres yazarak), etiket ve buton/bağlantı alanları bulunur. "Link Türü": URL / Sayfa, Kategori veya Form (aynı sayfada açılır; "Form Seç" ile seçilir); "Kartta görünen yazı" butonda/bağlantıda görünen metindir. Fiyat paketi kartlarında Paket adı, Fiyat, Fiyat eki, Buton metni ve "Öne çıkan / popüler paket"; kampanya kartında İndirim yüzdesi, Kampanya tarihi (Başlangıç / Bitiş), Alt yazı / CTA ve panel rengi vardır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Promo ve görselli şablonlarda Görsel URL zorunludur. Kampanya kartında görsel yoksa kart ikiye bölünür: solda indirim ve ad, sağda tarih ve CTA.'),
        t(`${G}.s4.tip2`, 'Değerler şeridinde ikon rengi boşsa site rengi kullanılır; her kartta ayrı renk seçebilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kart ekleyin, kopyalayın, silin'),
      text: t(`${G}.s5.text`, '"Kart Ekle" yeni kart açar; bir blokta en fazla 12 kart olur (düğmede sayı yazar). Kart başlığındaki simgelerle kartı taslak alırsınız veya silersiniz. "Taslağı yapıştır" taslak aldığınız kartı bu bloğa ekler; böylece kartı başka bir bloğa taşıyabilirsiniz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Taslak bu tarayıcıda saklanır; başka bilgisayarda veya tarayıcıda yapıştırılamaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Önizleyin ve kaydedin'),
      text: t(`${G}.s6.text`, 'Alttaki "Canlı Önizleme" kartların sitede nasıl görüneceğini gösterir. Pencere yazarken otomatik kaydeder; "Kapat" bekleyen değişikliği de kaydedip pencereyi kapatır. "Sayfaya Ekle" (düzenlemede "Kaydet") bloğu kaydedip kapatır; bunun için her kartın başlığı dolu olmalıdır, diğer alanlar isteğe bağlıdır.'),
    },
  ],
});
